import {ngAsync} from 'shared/utils/ng-@decorators';
import type RecordDataService from '../../record/record.data-service';
import type {RecordDescriptor} from 'typings/portaro.be.types';


export default class ThesaurusService {
    public static readonly serviceName = 'thesaurusService';

    /*@ngInject*/
    constructor(private recordDataService: RecordDataService) {
    }

    @ngAsync()
    public async getHierarchyRoot(): Promise<RecordDescriptor> {
        const rootRecord = await this.recordDataService.getHierarchyRoot();
        this.extendAuthority(rootRecord, 'ROOT');
        return rootRecord;
    }

    @ngAsync()
    private async loadRelatives(record) {
        const subauthoritiesLoad = this.loadSubauthorities(record);
        const seesLoad = this.loadSees(record);
        const seeAlsosLoad = this.loadSeeAlsos(record);

        await Promise.all([subauthoritiesLoad, seesLoad, seeAlsosLoad]);
        record.relativesShown = true;
    }

    private extendAuthority(a, type: string) {
        a.type = type;
        a.toggleRelatives = () => {
            if (!a.relativesShown) {
                this.loadRelatives(a);
            }
            a.relativesShown = !a.relativesShown;
        };
    }

    private async loadSees(record) {
        if (record.sees) {
            return;
        }
        const records = await this.recordDataService.query({seenRecord: record.id});
        records.forEach((r) => this.extendAuthority(r, 'SEE'));
        record.sees = records;
    }

    private async loadSeeAlsos(record) {
        if (record.seeAlsos) {
            return;
        }
        const records = await this.recordDataService.query({seenAlsoRecord: record.id});
        records.forEach((r) => this.extendAuthority(r, 'SEE_ALSO'));
        record.seeAlsos = records;
    }

    private async loadSubauthorities(record) {
        if (record.subauthorities) {
            return;
        }
        const records = await this.recordDataService.query({superRecord: record.id});
        records.forEach((r) => this.extendAuthority(r, 'SUBAUTHORITY'));
        record.subauthorities = records;
    }
}